import React from 'react';
import classNames from 'classnames';
import styles from './ProgressBar.module.scss';
import TestIds from '../../tests/TestIds';

interface Props {
	className?: string;
	progressClassName?: string;
	progressPercentage: number;
	reversed?: boolean;
}

const ProgressBar = ({
	className,
	progressClassName,
	progressPercentage = 0,
	reversed = false,
}: Props) => {
	const value = reversed ? 100 - progressPercentage : progressPercentage;
	return (
		<div className={classNames(styles.bar, className)} data-cy={TestIds.ProgressBar}>
			<div
				className={classNames(
					styles.progress,
					reversed ? styles.remaining : styles.expired,
					progressClassName
				)}
				style={{ width: `${value}%` }}
			/>
			<div
				className={classNames(
					styles.progress,
					reversed ? styles.expired : styles.remaining,
					progressClassName
				)}
				style={{ width: `${100 - value}%` }}
			/>
		</div>
	);
};

export default ProgressBar;
